import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'input-wrapper',
  imports: [CommonModule],
  templateUrl: './input-wrapper.component.html',
  styleUrl: './input-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputWrapperComponent {
  error = input<boolean>(false);
}
